import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import Employees from './Employees';
import Reports from './Reports';
import TenantsAdmin from './TenantsAdmin';
import Kiosk from './Kiosk';

export const getToken = () => localStorage.getItem('nexus_jwt');
export const setToken = (t) => localStorage.setItem('nexus_jwt', t);
export const clearToken = () => localStorage.removeItem('nexus_jwt');

function ProtectedRoute({ children }) {
    const token = getToken();
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function SuperAdminRoute({ children }) {
    const token = getToken();
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    try {
        const u = JSON.parse(localStorage.getItem('nexus_user') || 'null');
        if (!u || u.role !== 'superadmin') {
            return <Navigate to="/dashboard" replace />;
        }
    } catch {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function TenantRoute({ children }) {
    const token = getToken();
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    try {
        const u = JSON.parse(localStorage.getItem('nexus_user') || 'null');
        if (u && u.role === 'superadmin') {
            return <Navigate to="/superadmin/tenants" replace />;
        }
    } catch {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function DashboardRoute({ children }) {
    const token = getToken();
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    try {
        const u = JSON.parse(localStorage.getItem('nexus_user') || 'null');
        if (u && u.role === 'superadmin') {
            return <Navigate to="/superadmin/tenants" replace />;
        }
    } catch {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/terminal-de-fichaje" element={<Kiosk />} />
                <Route path="/kiosco" element={<Navigate to="/terminal-de-fichaje" replace />} />
                <Route
                    path="/dashboard"
                    element={
                        <DashboardRoute>
                            <Dashboard />
                        </DashboardRoute>
                    }
                />
                <Route
                    path="/dashboard/employees"
                    element={
                        <TenantRoute>
                            <Employees />
                        </TenantRoute>
                    }
                />
                <Route
                    path="/dashboard/reports"
                    element={
                        <TenantRoute>
                            <Reports />
                        </TenantRoute>
                    }
                />
                <Route
                    path="/superadmin/tenants"
                    element={
                        <SuperAdminRoute>
                            <TenantsAdmin />
                        </SuperAdminRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
